import { BaseRestRepository } from './baseRestRepository';
import type { CompanyReferralLinkDto } from '~/swagger/portal/Api';

const BASE_URL = '/api/referrals/link';

export class ReferralRepository extends BaseRestRepository {
  public async getReferralLink(): Promise<CompanyReferralLinkDto> {
    const url = BASE_URL;
    const response = await this.fetchWithAuth(url, {
      method: 'GET',
    });
    return this.getJsonResponse(response);
  }
}
